import { render, staticRenderFns } from "./12.vue?vue&type=template&id=0fe04a66&scoped=true&"
var script = {}
import style0 from "./12.vue?vue&type=style&index=0&id=0fe04a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe04a66",
  null
  
)

export default component.exports